// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3GAv5","head":"ProcedureTableInfo_head__2Mu6y"};